<template>
    <section class="p-2 widget my-2">
        <div class="row">
            <div class="col-12">
                <a
                    class="font-weight-bold float-right "
                    :class="
                        canAddClient
                            ? 'text-primary cursor-pointer'
                            : 'text-muted cursor-not-allowed'
                    "
                    @click="ccCanViewUserAccounts ? showAssignResource() : null"
                    >Edit</a
                >
                <p class="text-uppercase font-weight-bold mb-0">
                    Therapists assigned to {{ patient.first_name }}
                </p>
                <p v-for="t in patient.therapists" class="mb-0">
                    {{ t.name }}{{ t.title ? `, ${t.title}` : "" }}
                </p>
            </div>
        </div>
        <assign-resource
            :key="'therapists'"
            :user="user"
            :organization="organization"
            :resource="'therapists'"
            :selectedAssignee="patient_"
            :visible="isAssignResourceVisible"
            @handle-close="hideAssignResource"
            @update-resource="fetchPatient()"
        ></assign-resource>
    </section>
</template>

<script>
import AssignResource from "../widgets/AssignResource";
import { permissions } from "../../plugins/permissions";

export default {
    name: "PatientTherapists",
    props: ["patient", "organization", "user"],
    mixins: [permissions],
    components: { AssignResource },
    data() {
        return {
            isAssignResourceVisible: false,
            patient_: {},
        };
    },
    watch: {
        isAssignResourceVisible() {
            if (this.isAssignResourceVisible) {
                this.patient_ = { ...this.patient };
            }
        },
    },
    methods: {
        showAssignResource() {
            this.isAssignResourceVisible = true;
        },

        hideAssignResource() {
            this.isAssignResourceVisible = false;
            this.$emit("update-resource");
        },

        fetchPatient() {
            axios
                .get(`/api/patients/${this.patient.id}`)
                .then(r => {
                    this.patient_ = r.data.data;
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped></style>
